import React, { useEffect, useState } from "react";
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import Slider from '@mui/material/Slider';
import Box from '@mui/material/Box';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Snackbar from '@mui/material/Snackbar';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { db, firebase_update_device_setting} from "../firebase";

const styles = {
  dial: {
    width: `auto`,
    height: `auto`,
    color: "#000",
    border: "0.5px solid #fff",
    padding: "2px"
  },
  title: {
    fontSize: "1em",
    color: "#000"
  }
};

const LevelSetting = ({ deviceId, id, hardware_status, full_level, full_tank, min_level, warning_threshold }) => {
    const [fullLevel, setFullLevel] = useState(full_level);
    const [fullTank, setFullTank] = useState(full_tank);
    const [minLevel, setMinLevel] = useState(min_level);
    const [warningThreshold, setWarningThreshold] = useState(warning_threshold);
    const [hardwareInstall, setHardwareInstall] = useState(hardware_status=='installed');
    const [openChangeSnackbar, setOpenChangeSnackbar] = useState(false);
    const [changeMessage, setChangeMessage] = useState();


    useEffect(() => {
        setFullLevel(full_level);
        setFullTank(full_tank);
        setMinLevel(min_level);
        setHardwareInstall(hardware_status=='installed');     
    }, [hardware_status, full_level, full_tank, min_level]);

    const handleFullLevelChange = (event, newValue) => {
        if (typeof newValue === 'number') {
        setFullLevel(newValue);
        }
    };

    const handleFullLevelUpdateFirebase = (event, newValue) => {
        if (typeof newValue === 'number') {
            firebase_update_device_setting(deviceId + '/sensor_info/level/full_level', newValue.toString());
            setFullLevel(newValue);      
            setChangeMessage("Change full level to " + newValue + "%"); 
            setOpenChangeSnackbar(true);          
        }
    };

    const handleFullTankChange = (event, newValue) => {
        if (typeof newValue === 'number') {
            setFullTank(newValue);
        }
    };

    const handleFullTankUpdateFirebase = (event, newValue) => {
        if (typeof newValue === 'number') {
            firebase_update_device_setting(deviceId + '/sensor_info/level/full_tank', newValue.toString());
            setFullTank(newValue);            
            setChangeMessage("Change full tank capacity to " + newValue + " kg"); 
            setOpenChangeSnackbar(true);          
        }
    };

    const handleMinLevelChange = (event, newValue) => {
      if (typeof newValue === 'number') {
      setMinLevel(newValue);
      }
  };

  const handleMinLevelUpdateFirebase = (event, newValue) => {
      if (typeof newValue === 'number') {
          firebase_update_device_setting(deviceId + '/sensor_info/level/min_level', newValue.toString());
          setMinLevel(newValue);      
          setChangeMessage("Change minimul level to " + newValue + "%"); 
          setOpenChangeSnackbar(true);          
      }
  };

  const handleWarningThresholdChange = (event, newValue) => {
    if (typeof newValue === 'number') {
    setWarningThreshold(newValue);
    }
};

const handleWarningThresholdUpdateFirebase = (event, newValue) => {
    if (typeof newValue === 'number') {
        firebase_update_device_setting(deviceId + '/sensor_info/level/warning_threshold', newValue.toString());
        setWarningThreshold(newValue);      
        setChangeMessage("Change warning threshold to " + newValue + "%"); 
        setOpenChangeSnackbar(true);          
    }
};

    const handleHardwareInstallChange = (event) => {
        if(event.target.checked)
        {
            firebase_update_device_setting(deviceId + '/sensor_info/level/hardware_status', "installed");
            setChangeMessage("Level sensor hardware has been installed.")
        }
        else
        {
            firebase_update_device_setting(deviceId + '/sensor_info/level/hardware_status', "not_installed");
            setChangeMessage("Level sensor hardware has not been installed.")
        }
        setHardwareInstall(event.target.checked);
        setOpenChangeSnackbar(true);
    }

    const handleCloseChangeMessageSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpenChangeSnackbar(false);
      };

    return (
            <Stack direction="column" style={{width: "100%"}}>       
                <Box sx={{ width: "100%", pb: 3}}>
                <FormGroup>
                    <FormControlLabel control={<Switch disabled={sessionStorage.getItem('power_user')=="false"} checked={hardwareInstall} />} label={hardwareInstall ? "Installed" : "Not Installed"} onChange={handleHardwareInstallChange} />
                </FormGroup>
                </Box>                       
                <Box sx={{ width: "100%" }}>
                  <Typography gutterBottom variant="caption">
                      Full Level: {fullLevel}%
                    </Typography>
                  <Slider 
                    disabled={hardwareInstall==false}
                    value={fullLevel} 
                    min={50}
                    max={100}
                    onChange={handleFullLevelChange}
                    onChangeCommitted={handleFullLevelUpdateFirebase}
                    aria-label="Max rate slider" />
                </Box>
                <Box sx={{ width: "100%" }}>
                  <Typography gutterBottom variant="caption">Full Tank Capacity: {parseInt(fullTank).toLocaleString()} kg</Typography>
                  <Slider                   
                    disabled={hardwareInstall==false}
                    value={fullTank} 
                    min={3000}
                    max={25000}
                    step={10}
                    onChange={handleFullTankChange}
                    onChangeCommitted={handleFullTankUpdateFirebase}
                    aria-label="Max value slider" />
                </Box>
                <Box sx={{ width: "100%" }}>
                  <Typography gutterBottom variant="caption">Minimum Level: {minLevel}%</Typography>
                  <Slider                   
                    disabled={hardwareInstall==false}
                    value={minLevel} 
                    min={0}
                    max={50}
                    onChange={handleMinLevelChange}
                    onChangeCommitted={handleMinLevelUpdateFirebase}
                    aria-label="Min Level slider" />
                </Box>
                <Box sx={{ width: "100%" }}>
                  <Typography gutterBottom variant="caption">Warning Threshold: {warningThreshold}%</Typography>
                  <Slider                   
                    disabled={hardwareInstall==false}
                    value={warningThreshold} 
                    min={10}
                    max={80}
                    onChange={handleWarningThresholdChange}
                    onChangeCommitted={handleWarningThresholdUpdateFirebase}
                    aria-label="Warning threshold slider" />
                </Box>
                <Snackbar
                  open={openChangeSnackbar}
                  autoHideDuration={6000}
                  onClose={handleCloseChangeMessageSnackbar}
                  message={changeMessage}
                /> 
            </Stack>
  );
};

export default LevelSetting;
